import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LaudoHigienizacaoService } from 'src/app/services/LaudoHigienizacaoService/laudo-higienizacao.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-inserir-informacoes-laudo',
  templateUrl: './inserir-informacoes-laudo.component.html',
  styleUrls: ['./inserir-informacoes-laudo.component.scss']
})
export class InserirInformacoesLaudoComponent {
  form: FormGroup;
  activeRoute: string = '';
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private laudoHigienizacaoService: LaudoHigienizacaoService,
    public swalAlert: SwalAlertService
  ) {
    this.form = this.initForm();
  }

  initForm(): FormGroup {
    return this.fb.group({
      TX_CNPJ_EPSA: [null, [Validators.required, Validators.minLength(11)]],
      PK_LAUD_SRVC: [null, Validators.required]
    });
  }

  onSubmit(): void {
    const TX_CNPJ_EPSA = this.form.value.TX_CNPJ_EPSA;
    const PK_LAUD_SRVC = this.form.value.PK_LAUD_SRVC;
    this.isLoading = true;
    this.laudoHigienizacaoService
      .GetLaudoServicoByCnpj(TX_CNPJ_EPSA, PK_LAUD_SRVC)
      .subscribe({
        next: res => {
          this.isLoading = false;
          if (!res.PK_LAUD_SRVC) {
            this.swalAlert.showAlert('Atenção!', 'Não foi possível encontrar o laudo!', 'warning');
          }
          this.router.navigate(['visualizar-laudo'], {
            queryParams: {
              PK_LAUD_SRVC: res.PK_LAUD_SRVC
            }
          });
        },
        error: err => {
          this.isLoading = false;
          this.swalAlert.showAlert('Atenção!', 'Não foi possível encontrar o laudo!', 'warning');
        }
      });
  }
}
